export default __webpack_public_path__ + "static/media/Test1.71f87bb4.png";